import { render, staticRenderFns } from "./EDSRequest.vue?vue&type=template&id=7ffd064e&"
import script from "./EDSRequest.vue?vue&type=script&lang=js&"
export * from "./EDSRequest.vue?vue&type=script&lang=js&"
import style0 from "./EDSRequest.vue?vue&type=style&index=0&id=7ffd064e&prod&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports